import { useState, useCallback, useEffect } from "react";
import { memoryStore } from "../utils/storage";

const SNAPSHOT_KEY = "pension_snapshot_v1";

function loadAll() {
  try {
    const raw = memoryStore.getItem(SNAPSHOT_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch { return {}; }
}

function saveAll(all) {
  try { memoryStore.setItem(SNAPSHOT_KEY, JSON.stringify(all)); } catch {}
}

export function useSnapshotStore(clientId) {
  const [snapshot, setSnapshot] = useState(() => {
    const all = loadAll();
    return all[clientId] || { globalComment: "", fundComments: {} };
  });

  useEffect(() => {
    const onSync = () => {
      const all = loadAll();
      setSnapshot(all[clientId] || { globalComment: "", fundComments: {} });
    };
    window.addEventListener('pension-data-synced', onSync);
    return () => window.removeEventListener('pension-data-synced', onSync);
  }, [clientId]);

  const persist = useCallback((newSnapshot) => {
    const all = loadAll();
    all[clientId] = newSnapshot;
    saveAll(all);
  }, [clientId]);

  const updateGlobalComment = useCallback((text) => {
    setSnapshot(prev => {
      const next = { ...prev, globalComment: text };
      persist(next);
      return next;
    });
  }, [persist]);

  const updateFundComment = useCallback((fundId, text) => {
    setSnapshot(prev => {
      const next = {
        ...prev,
        fundComments: { ...prev.fundComments, [fundId]: text }
      };
      persist(next);
      return next;
    });
  }, [persist]);

  const clearSnapshot = useCallback(() => {
    setSnapshot({ globalComment: "", fundComments: {} });
    persist({ globalComment: "", fundComments: {} });
  }, [persist]);

  return { snapshot, updateGlobalComment, updateFundComment, clearSnapshot };
}
